import Raven from 'raven-js'

function configSentry() {
  return Raven.config(
    'https://a0c89d6da7b5423d829c50df30346e5e@sentry.io/1489328'
  ).install()
}
export default configSentry()



// WEBPACK FOOTER //
// /opt/build/repo/src/sentry.js